import React from "react";
import {
    Cascader,
    TreeSelect,
} from "antd";

import { reqUserList } from "../../api";
import memory from "../../utils/memory";

export default class UserSelector extends React.Component {
    state = {
        treeData: [],
        value: []
    };
    type = this.props.type || 1; // 使用用户_id为1，使用钉钉userId为2
    userObj = {};
    departmentObj = {};
    menus = [];
    pathRefer = {}
    getTreeNodes = (arr, departmentObj, userObj, path = []) => {
        if (arr) {

            for (let i = 0; i < arr.length; i++) {
                if (departmentObj[arr[i].id] || userObj[arr[i].id]) {
                    if (departmentObj[arr[i].id]) {
                        arr[i].children = [...departmentObj[arr[i].id]];
                    }

                    if (userObj[arr[i].id]) {
                        if (arr[i].children) {
                            let tmpArr = [...arr[i].children];
                            tmpArr = tmpArr.concat(userObj[arr[i].id].map(item => {
                                if (!this.pathRefer[item.id] || ([...path, item.value].length > this.pathRefer[item.id].length)) {

                                    this.pathRefer = {
                                        ...this.pathRefer,
                                        [item.id]: [...path, arr[i].id, item.value]
                                    }
                                }
                                return item
                            }));
                            arr[i].children = tmpArr;
                        } else {
                            arr[i].children = [...userObj[arr[i].id].map(item => {


                                if (!this.pathRefer[item.id] || ([...path, item.value].length > this.pathRefer[item.id].length)) {

                                    this.pathRefer = {
                                        ...this.pathRefer,
                                        [item.id]: [...path, arr[i].id, item.value]
                                    }
                                }
                                return item
                            })];
                        }
                    }
                    this.getTreeNodes(arr[i].children, departmentObj, userObj, [...path, arr[i].id]);
                }
            }
            return arr;
        }
    };

    getUserList = async (params = {}) => {
        const users = await reqUserList(params);
        if (users && users.data) {
            for (let i = 0; i < memory.departments.length; i++) {
                let item = memory.departments[i];
                if (!item.parentid) {
                    continue;
                }
                if (item.parentid !== 1) {
                    if (!this.departmentObj[item.parentid]) {
                        this.departmentObj[item.parentid] = [];
                    }
                    this.departmentObj[item.parentid].push({
                        id: item.id,
                        key: Math.random().toString(32).slice(2, 10),
                        value: item.id,
                        label: item.name,
                        selectable: false,
                    });
                } else {
                    this.menus.push({
                        id: item.id,
                        key: Math.random().toString(32).slice(2, 10),
                        value: item.id,
                        label: item.name,
                        selectable: false
                    });
                }
            }

            for (let i = 0; i < users.data.data.length; i++) {
                let item = users.data.data[i];
                if (item && item.dd_info.department) {
                    for (let j = 0; j < item.dd_info.department.length; j++) {
                        let department = item.dd_info.department[j];
                        if (department === 1) {
                            if (this.type === 1) {
                                this.menus.push({
                                    id: item._id,
                                    key: Math.random().toString(32).slice(2, 10),
                                    value: item._id,
                                    label: item.dd_info.name
                                });
                            } else {
                                this.menus.push({
                                    id: item.dd_info.userid,
                                    value: item.dd_info.userid,
                                    key: Math.random().toString(32).slice(2, 10),
                                    label: item.dd_info.name
                                });
                            }
                        } else {
                            if (!this.userObj[department]) {
                                this.userObj[department] = [];
                            }
                            if (this.type === 1) {
                                this.userObj[department].push({
                                    key: Math.random().toString(32).slice(2, 10),
                                    id: item._id,
                                    value: item._id,
                                    label: item.dd_info.name
                                });
                            } else {
                                this.userObj[department].push({
                                    key: Math.random().toString(32).slice(2, 10),
                                    id: item.dd_info.userid,
                                    value: item.dd_info.userid,
                                    label: item.dd_info.name
                                });
                            }
                        }
                    }
                }
            }

            const result = this.getTreeNodes(this.menus, this.departmentObj, this.userObj);
            this.setState({
                treeData: result,
                value: this.props.value || []
            });
        }


        if (this.id) {
            // 获取详情
            this.getSellerDetail({
                id: this.id
            });
        }
    };

    handleChange = (value) => {
        let id = ""
        let tempValue
        if (Object.prototype.toString.call(value.at(-1)) == '[object Array]') {
            //筛出选中的所有字符串ID
            tempValue = [...value.slice()].flat().filter(item => Object.prototype.toString.call(item) == '[object String]')
            if (this.props?.multiple) {
                id = tempValue
            } else {
                //不是多选，只返回选中的那个//筛出选中的所有字符串ID
                id = tempValue.at(-1)
            }
        } else if (Object.prototype.toString.call(value.at(-1)) == '[object String]') {
            id = value.at(-1)
        }
        this.setState({ value: value });
        this.props.onChange(id);
    };

    componentDidMount() {
        this.getUserList({
            node: 999,
        });
        if (this.props?.value) {

            this.setState({ value:this.props?.value });
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
    }

    render() {
        const { treeData } = this.state;
        return (
            <Cascader
                {...this.props}
                style={{ width: '100%' }}
                options={treeData}
                onChange={this.handleChange}
                value={Object.prototype.toString.call(this.state.value) == '[object String]'
                    ? (this.pathRefer[this.state.value] || this.state.value)
                    : this.state.value
                }
                defaultValue={
                    Object.prototype.toString.call(this.state.value) == '[object String]'
                        ? (this.pathRefer[this.state.value] || this.state.value)
                        : this.state.value
                }
                maxTagCount="responsive"
                showCheckedStrategy={Cascader.SHOW_CHILD}
            />
        );
    }
}

/*}TreeSelect
              {...this.props}
              treeNodeFilterProp={"title"}
              value={this.state.value}
              allowClear
              treeCheckable={false}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              treeData={treeData}
              onChange={this.handleChange}
          />*/